const demoraInitialState = {
    demora: {
      data: null,
      loading: false,
      error: false,
    },
  };
  
  export default demoraInitialState;